import { render, staticRenderFns } from "./RequestBuyPage.vue?vue&type=template&id=f9f1bfea&scoped=true"
import script from "./RequestBuyPage.vue?vue&type=script&lang=ts"
export * from "./RequestBuyPage.vue?vue&type=script&lang=ts"
import style0 from "./RequestBuyPage.vue?vue&type=style&index=0&id=f9f1bfea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f1bfea",
  null
  
)

export default component.exports